import React, { useState } from 'react';
import {
  Container,
  Paper,
  Tabs,
  Tab,
  Box
} from '@mui/material';
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import AdminEmployeeForm from './AdminEmployeeForm';


const AdminEmployeeFormWithTabs = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

   const token = localStorage.getItem('token');
      if (!token) {
      alert("No authentication token found. Please log in.");
        return;
      }

      // Decode token to get user ID
      const payload = JSON.parse(atob(token.split('.')[1]));
      const userId = payload.id;
  const userRole = payload.role || 'admin';
  const companyId = payload.company_id || '';


  return (
    <Container maxWidth="lg" sx={{ width:'1200px' }}>

       

        <Box sx={{ p: 3 }}>
          {currentTab === 0 && (
            <AdminEmployeeForm 
              userId={userId} 
              userRole={userRole} 
              companyId={companyId} 
            />
          )}
        
        </Box>
  
    </Container>
  );
};

export default AdminEmployeeFormWithTabs;